<template>
  <div class="pmMonitor-bar" ref="pmMonitor">
    <div class="titleCtrl-bar">
      <a
        :class="getTypeCtrlClass(item)"
        v-bind:key="item"
        v-for="(item, i) in companyList"
        @click="switchTab(item, i)"
        >{{ item }}</a
      >

      <a class="historyDetail-btn" @click="historicalTrendCheck">历史趋势</a>

      <a class="lookMore-btn" @click="lookMoreCheck">查看全部 ☰</a>
    </div>
    <div class="content-bar">
      <el-carousel
        ref="carousel"
        height="185px"
        :initial-index="curIndex"
        @change="carouselChange($event)"
        :autoplay="false"
        :interval="interval"
        arrow="never"
      >
        <el-carousel-item v-for="item in getCarouselLen" :key="item">
          <div class="panel-bar" v-for="panel in 5" :key="panel">
            <circle-bar
              :circleData="
                curList[panel - 1 + 5 * curIndex]
                  ? curList[panel - 1 + 5 * curIndex]
                  : null
              "
            />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import circleBar from "./components/circle.vue";
import { mapState, mapGetters } from "vuex";
import historicalTrend2 from "./components/historicalTrend2";
import showMorePage from "./components/showMorePage";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { circleBar },
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      standardList: [0, 5, 10, 15, 20, 25, 30],
      companyList: [],
      companyIndex: 0,
      curList: [],
      dataObj: {},
      curIndex: 0,
      interval: 10000,
      timer: null,
    };
  },
  //计算属性 类似于data概念
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    getTypeCtrlClass() {
      return (item) => {
        let typeName = this.companyList[this.companyIndex];
        if (item === typeName) {
          return "typeCtrl-btn typeCtrl-selected";
        } else {
          return "typeCtrl-btn";
        }
      };
    },
    getCarouselLen() {
      if(this.curList.length == 0) {
        return 5
      } else {
        return Math.ceil(this.curList.length / 5);
      }
    },
    getStandardPos() {
      return function (item) {
        if (item === 0) {
          return {
            position: "absolute",
            top: "70px",
            left: "20px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 1) {
          return {
            position: "absolute",
            top: "40px",
            left: "10px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 2) {
          return {
            position: "absolute",
            top: "15px",
            left: "20px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 3) {
          return {
            position: "absolute",
            top: "5px",
            left: "50px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 4) {
          return {
            position: "absolute",
            top: "15px",
            left: "75px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 5) {
          return {
            position: "absolute",
            top: "40px",
            left: "89px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        } else if (item === 6) {
          return {
            position: "absolute",
            top: "70px",
            left: "83px",
            fontFamily: "number",
            fontSize: "12px",
            transform: "scale(0.8)",
            transformOrigin: "center center",
            color: "#DDD",
          };
        }
      };
    },
  },
  //监控data中的数据变化
  watch: {
    curIndex: {
      handler(newVal, oldVal) {
        //this.interval = 10000;
        //alert(newVal);
        this.curIndex = newVal;

        let len = Math.ceil(this.curList / 5);
        let that = this;
        if (newVal + 1 <= len) {
          setTimeout(function () {
            that.$refs.carousel.setActiveItem(0);
            that.curIndex = 0;
          }, 5000);
        }
      },
      deep: true,
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  async mounted() {
    let that = this;
    let w = $(that.$refs.pmMonitor).outerWidth();
    let h = $(that.$refs.pmMonitor).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });

    let resultObj = {};
    resultObj = await this.getQgDevicesByType();
    that.dataObj = resultObj;
    for (let i in resultObj) {
      that.companyList.push(i);
    }

    let companyKey = that.companyList[that.companyIndex];
    that.$nextTick(() => {
      let curList = [];
      try {
        that.dataObj[companyKey].forEach((element) => {
          curList.push(element["list"][0]);
        });
        that.curList = curList;
        that.$nextTick(() => {
          that.$refs.carousel.setActiveItem(0);
          that.curIndex = 0;
        });
        that.$forceUpdate();
      } catch (err) {
        console.log(err);
      }
    });
  },
  unmounted() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  //方法集合
  methods: {
    switchTab(item, i) {
      let arr = [];
      this.dataObj[item].forEach((x) => {
        arr.push(x.list[0]);
      });
      this.curList = arr;
      this.companyIndex = i;
    },
    historicalTrendCheck() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(historicalTrend2, this.dialogCompontent, this);
    },
    carouselChange(e) {
      this.curIndex = e;
      //let that = this;
      // alert(222);
      /*for (let i = 0; i < 5; i++) {
        let tmpId = that.curList[i]["typeId"];
        that.changeRotate(20, $(that.$refs["canvas-" + tmpId]).get(0));
      }*/
    },
    async getQgDevicesByType() {
      let getQgDevicesByTypeUrl =
        CONFIG.requestName + this.$apiOpt.getQgDevicesByType;
      return this.$apiUtils.get(getQgDevicesByTypeUrl, {
        customerId: this.$store.state.customerId,
        type: 3,
      });
    },
    lookMoreCheck() {
      this.$store.commit("dialogStatus", true);
      this.$popup.open(showMorePage, this.dialogCompontent, this);
    },
  },
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.pmMonitor-bar {
  height: 250px;
  width: 900px;
  .titleCtrl-bar {
    position: absolute;
    top: 0px;
    right: 0px;
    padding: 20px;
    a {
      cursor: pointer;
    }
  }
  .typeCtrl-btn {
    height: 26px;
    background: rgba(0, 0, 0, 0.2);
    box-shadow: 0px 1px 0px 0px #5bb4ff;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 26px;
    display: inline-block;
    text-align: center;
    margin-right: 10px;
    padding: 0 10px;
    cursor: pointer;
  }

  .typeCtrl-selected {
    background: linear-gradient(138deg, #006dc9 0%, #00325d 100%);
    box-shadow: 0px 1px 0px 0px #5bb4ff, 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px;
  }

  .typeCtrl-btn:hover {
    background: linear-gradient(138deg, #006dc9 0%, #00325d 100%);
    box-shadow: 0px 1px 0px 0px #5bb4ff, 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px;
  }

  .historyDetail-btn {
    margin-left: 5px;
    width: 72px;
    height: 18px;
    font-size: 18px;
    font-weight: 400;
    color: #f4c48f;
    line-height: 18px;
    margin-right: 10px;
  }
  .lookMore-btn {
    width: 72px;
    height: 18px;
    font-size: 18px;
    font-weight: 400;
    color: #4be0ff;
    line-height: 18px;
  }

  .content-bar {
    position: relative;
    top: 40px;
  }

  .panel-bar {
    width: 164px;
    height: 160px;
    vertical-align: top;
    position: relative;
    display: inline-block;
    margin-right: 8px;
    background: rgba(0, 0, 0, 0.2);
    box-shadow: 0px 1px 1px 0px rgba(46, 130, 255, 0.41);
    border: 1px solid;
    border-image: linear-gradient(
        180deg,
        rgba(46, 74, 117, 1),
        rgba(46, 130, 255, 0),
        rgba(1, 191, 165, 0)
      )
      1 1;
  }

  .panel-inner {
    position: relative;
    width: 110px;
    height: 118px;
    background-size: 100% 100%;
    margin: 5px auto;
  }
  .panel-bg {
    background: url(img/pan.png);
    position: absolute;
    width: 110px;
    height: 118px;
    background-size: 100% 100%;
    z-index: 99;
  }

  .panel-handler {
    background: url(img/hand.png);
    position: absolute;
    width: 56px;
    height: 56px;
    background-size: 100% 100%;
    left: 27px;
    top: 27px;
    -webkit-transition: all 2s ease-out;
    -moz-transition: all 2s ease-out;
    transition: all 2s ease-out;
    transform: rotateZ(180deg);
  }

  .panel-number {
    width: 80px;
    height: 15px;
    font-size: 23px;
    font-family: "number";
    font-weight: 400;
    color: #47ffdd;
    line-height: 14px;
    position: absolute;
    top: 78px;
    left: 15px;
    text-align: center;
  }

  .panel-tag {
    width: 100px;
    height: 20px;
    font-size: 12px;
    font-family: "normalFont";
    font-weight: 400;
    color: #47ffdd;
    line-height: 20px;
    position: absolute;
    text-align: center;
    left: 5px;
    top: 102px;
    z-index: 100;
  }

  .panel-title {
    width: 150px;
    height: 14px;
    font-size: 12px;
    font-family: "normalFont";
    font-weight: 400;
    color: #c0d5d9;
    line-height: 14px;
    text-align: center;
    position: absolute;
    top: 135px;
    left: -20px;
  }

  .panel-content {
    position: absolute;
    top: 0px;
    left: 0px;
    transform-origin: top left;
  }
}
</style>
